import React, { memo, useMemo } from 'react';
import styled from 'styled-components';

import GRIconContainer from '../../modules/gift-race/components/GRIcon/GRIconContainer';
import { getGRLabelsBySkinId } from '../../modules/gift-race/constants/labels';
import { GRSkinId, GRSkinIds } from '../../modules/gift-race/types/global';
import {
  MenuDesktopArrowIcon,
  SportsMenuBtnContent,
  SportsMenuBtnLabel,
  SportsMenuListItem,
} from '../../styled-components/shared';
import Counter from '../Counter';

const StyledGRIcon = styled(GRIconContainer)`
  margin: 0 0.25em !important;
`;

type MenuDestkopGRButtonProps = {
  nbGRNotifications: number;
  openGRView: () => void;
  skinId: GRSkinId;
};

const MenuDestkopGRButton = ({
  nbGRNotifications,
  openGRView,
  skinId = GRSkinIds.GIFT_RACE,
}: MenuDestkopGRButtonProps) => {
  const menuLabel = useMemo(() => getGRLabelsBySkinId(skinId)?.OperationTitle, [skinId]);

  return (
    <SportsMenuListItem onClick={openGRView}>
      <SportsMenuBtnContent>
        <StyledGRIcon />
        <SportsMenuBtnLabel $separator={true}>
          {menuLabel}
          {nbGRNotifications ? <Counter counter={nbGRNotifications} /> : null}
        </SportsMenuBtnLabel>
      </SportsMenuBtnContent>
      <MenuDesktopArrowIcon className="see-all-btn" />
    </SportsMenuListItem>
  );
};

export default memo<MenuDestkopGRButtonProps>(MenuDestkopGRButton);
